import { REDUCER_KEY, I18N_KEY } from '../constants';


export const i18nSelector = state => state[REDUCER_KEY]?.[I18N_KEY] || {};
